import { SVGProps } from 'react';

interface InfoCircleIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Info Circle Icon
 *
 * Represents informational content and disclaimers.
 */
export function InfoCircleIcon({ size = 24, ...props }: InfoCircleIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 16v-4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="8" r="1" fill="currentColor" />
    </svg>
  );
}
